/* eslint-disable @typescript-eslint/no-explicit-any */
import { Extension } from "@tiptap/core";
import { Plugin, PluginKey } from "prosemirror-state";

import { getNumArray } from "@/lib/chillnn/get-num-array";
import { isInteger } from "@/lib/chillnn/is-integer";

export const EventHandler = (options: { uploader: (file: File) => Promise<string> }) =>
	Extension.create({
		name: "eventHandler",
		priority: -1,
		addProseMirrorPlugins() {
			return [
				new Plugin({
					key: new PluginKey("eventHandler"),
					props: {
						handleDOMEvents: {
							paste(this, view, event) {
								const temp = (event.clipboardData && event.clipboardData.items) || null;
								if (!temp || !temp.length) {
									return false;
								}
								let items = getNumArray(0, 1, temp.length).map(
									(idx) => ((temp as any).item && (temp as any).item(idx)) || temp[idx],
								);
								if (!options.uploader) {
									return false;
								}
								if (!Array.isArray(items)) {
									// 配列に変換する
									items = Object.keys(items)
										.filter((item) => isInteger(item))
										.map((item) => items[item as unknown as number]);
								}
								items.forEach(async (item) => {
									const { schema } = view.state;
									const image = item.getAsFile();
									// Return here, otherwise copying texts won't possible anymore
									if (!image) {
										return false;
									}
									event.preventDefault();
									// eslint-disable-next-line @typescript-eslint/no-unsafe-argument
									const imageSrc = await options.uploader(image);
									const node = schema.nodes.image.create({
										src: imageSrc,
									});
									const transaction = view.state.tr.replaceSelectionWith(node);
									view.dispatch(transaction);
								});
								return false;
							},
							drop(this: Plugin, view, event) {
								const hasFiles = event.dataTransfer && event.dataTransfer.files.length > 0;
								if (!hasFiles) {
									return false;
								}
								event.preventDefault();
								const { schema } = view.state;
								const coordinates = view.posAtCoords({
									left: event.clientX,
									top: event.clientY,
								});
								const temp = (event.dataTransfer && event.dataTransfer.files) || null;
								if (!temp) {
									return false;
								}
								let images = getNumArray(0, 1, temp.length).map((idx) => temp.item(idx));
								if (!Array.isArray(images)) {
									// 配列に変換する
									images = Object.keys(images as number[])
										.filter((item) => isInteger(item))
										.map((item) => images[item as unknown as number]) as File[];
								}
								images.forEach(async (image) => {
									if (!options.uploader) {
										return false;
									}
									const imageSrc = (image && (await options.uploader(image))) || null;
									if (imageSrc) {
										const node = schema.nodes.image.create({
											src: imageSrc,
										});
										if (coordinates) {
											const transaction = view.state.tr.insert(coordinates.pos, node);
											view.dispatch(transaction);
										}
									}
								});
								return false;
							},
						},
					},
				}),
			];
		},
	});
